import { useEffect, useState } from "react";
import { api, AppConfig, ApiError } from "../api/client";
import { useToast } from "../ui/toast";

/** Polityka prywatności — edit the privacy policy served to the client app via /config. */
export function PrivacyPolicy() {
  const toast = useToast();
  const [cfg, setCfg] = useState<AppConfig | null>(null);
  const [original, setOriginal] = useState<AppConfig | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.getConfig()
      .then((c) => { setCfg(c); setOriginal(c); })
      .catch((e: ApiError) => toast(e.status === 403 ? "Brak dostępu (owner-only)." : e.message));
  }, [toast]);

  if (!cfg || !original) return <div className="card empty">Ładowanie…</div>;
  const changed =
    cfg.privacy.text !== original.privacy.text || (cfg.privacy.textEn ?? "") !== (original.privacy.textEn ?? "");

  const save = async () => {
    setBusy(true);
    try {
      const saved = await api.saveConfig(cfg);
      setCfg(saved);
      setOriginal(saved);
      toast(`Zapisano politykę prywatności (wersja ${saved.privacy.version})`);
    } catch (e) {
      toast((e as ApiError).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card" style={{ padding: 20, maxWidth: 860 }}>
      <div className="section-title" style={{ marginBottom: 4 }}>Polityka prywatności</div>
      <div className="section-hint">
        Treść jest serwowana do aplikacji klienckiej (/config), publikowana pod
        {" "}<code>/polityka-prywatnosci</code> i pokazywana w karcie „O aplikacji". Każda zmiana
        <b>{" "}podbija wersję polityki</b> i wymusza ponowną akceptację u{" "}wszystkich
        klientów przy następnym uruchomieniu aplikacji (tak jak warunki licencji).
      </div>

      <div className="field" style={{ marginTop: 14 }}>
        <label className="label">Treść polityki prywatności</label>
        <textarea
          className="textarea"
          style={{ minHeight: 360 }}
          value={cfg.privacy.text}
          placeholder="Wpisz treść polityki prywatności, którą zaakceptuje użytkownik aplikacji…"
          onChange={(e) => setCfg({ ...cfg, privacy: { ...cfg.privacy, text: e.target.value } })}
        />
      </div>

      <div className="field" style={{ marginTop: 14 }}>
        <label className="label">Treść w języku angielskim (EN) — pokazywana klientom, którzy wybrali English</label>
        <textarea
          className="textarea"
          style={{ minHeight: 340 }}
          value={cfg.privacy.textEn ?? ""}
          placeholder="Enter the English version of the privacy policy…"
          onChange={(e) => setCfg({ ...cfg, privacy: { ...cfg.privacy, textEn: e.target.value } })}
        />
      </div>

      <div className="row" style={{ marginTop: 12 }}>
        <span className="faint" style={{ fontSize: 12 }}>Aktualna wersja: {original.privacy.version}</span>
        {changed && (
          <span className="badge st-expiring" style={{ marginLeft: 8 }}>
            <span className="dot dot-expiring" />wersja zostanie podbita
          </span>
        )}
        <div className="topbar-spacer" />
        <button className="btn primary" disabled={busy || !changed} onClick={save}>Zapisz politykę</button>
      </div>
    </div>
  );
}
